import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { LegFiJwtService } from '../auth/legfi-jwt.service';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { PennySource } from '../ai.service';

export interface PennyPortalConfig {
    enabled: boolean;
    pennyName?: string;
    welcomeMessage?: string;
    showSourceCitations?: boolean;
}

export interface PennyPortalMessageResponse {
    conversationId: string;
    answer: string;
    sources: PennySource[];
}

export interface PennyPortalConversationMessage {
    messageId?: number;
    id?: number;
    role: 'user' | 'assistant';
    content: string;
    sources?: PennySource[];
}

export interface PennyPortalConversationResponse {
    conversationId: string;
    messages: PennyPortalConversationMessage[];
}

export type PennyFeedbackRating = 'thumbs_up' | 'thumbs_down';

@Injectable({
    providedIn: 'root',
})
export class PennyPortalService {
    constructor(private _http: ApplicationHttpClient) {
    }

    getConfig(): Observable<PennyPortalConfig> {
        const jwt = LegFiJwtService.read();
        return this._http.get<PennyPortalConfig>(Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PennyPortalConfig(jwt.orgId)));
    }

    sendMessage(message: string, conversationId?: string): Observable<PennyPortalMessageResponse> {
        const jwt = LegFiJwtService.read();
        const body: { message: string; conversationId?: string } = { message };
        if (conversationId) {
            body.conversationId = conversationId;
        }
        return this._http.post<PennyPortalMessageResponse>(
                Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PennyPortalMessage(jwt.orgId)),
                JSON.stringify(body),
        );
    }

    getConversation(conversationId: string): Observable<PennyPortalConversationResponse> {
        const jwt = LegFiJwtService.read();
        return this._http.get<PennyPortalConversationResponse>(
                Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PennyPortalConversation(jwt.orgId, conversationId)),
        );
    }

    submitFeedback(conversationId: string, messageId: number, rating: PennyFeedbackRating): Observable<unknown> {
        const jwt = LegFiJwtService.read();
        return this._http.post<unknown>(
                Routes.MakeLegFiCoreUrl(Routes.LegFiCore.PennyPortalConversationFeedback(jwt.orgId, conversationId)),
                JSON.stringify({ messageId, rating }),
        );
    }
}
